var exports = {
  "Ve": "ThemeTab.module__themeButtonGroup___b3M2NE",
  "mB": "ThemeTab.module__themeButton___b3M2NE",
  "RL": "ThemeTab.module__themeButtonSelected___b3M2NE",
  "Uk": "ThemeTab.module__themeButtonLight___b3M2NE",
  "sy": "ThemeTab.module__themeButtonDark___b3M2NE",
  "H2": "ThemeTab.module__themeButtonIcon___b3M2NE",
  "zO": "ThemeTab.module__themeButtonCheckmark___b3M2NE",
  "Qs": "ThemeTab.module__themeButtonCheckmarkIcon___b3M2NE",
};

module.exports = exports;
